export const GET_TIRE_MODEL_BEGIN = "GET_TIRE_MODEL_BEGIN"
export const GET_TIRE_MODEL_SUCCESS = "GET_TIRE_MODEL_SUCCESS"